import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import Avatar from "@mui/material/Avatar";
import { Link } from "react-router-dom";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { NavLink } from "react-router-dom";
import SideBar from "../sidebar/sidebar";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { notification_success } from "../../Redux/ActionCreator"
import NotificationModal from "../common/Notification/NotificationModal";
// import GoogleTranslate from "./googleTranslate";
import TranslateButton from "../translate_btn";
import { baseURL } from "../../Redux/baseURL";
import { NotificationSvg, NoNotificationSvg } from "../common/svgs/svgs";
import { Popover } from "@mui/material";

const TopBar = (props) => {
  const navigate = useNavigate();
  const t_lang = useSelector((lg) => lg.t_lang);
  const profile_stat = useSelector((prev) => prev.login);
  const employee = useSelector((e) => e.profile.message);
  const employer = useSelector((e) => e.employer.message);
  const msg_notification = useSelector(e => e.msg_notification);
  const trans = useSelector((e) => e.t_lang);
  const dispatch = useDispatch();
  const [anchorEL, setAnchorEL] = useState(null);
  const [anchorELProf, setAnchorELProf] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const open = Boolean(anchorEL);
  const openProf = Boolean(anchorELProf);
  const [showNot, setShowNot] = useState(false);
  const notify = useSelector(e => e.notification);
  let notification_list = notify.message;
  const sidebar = useSelector(e => e.sidebarOpen.message);
  const handleClick = (event) => {
    setAnchorEL(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEL(null);
  };
  const id = open ? 'notification-popover' : undefined;
  const idProfile = openProf ? 'profile-popover' : undefined;

  // function to toggle the mobile navigation
  const handleToggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleCloseProf = () => {
    setAnchorELProf(null);
  };

  const handleClickProf = (event) => {
    if (anchorELProf) {
      setAnchorELProf(null); // close profile popover if open
    } else {
      setAnchorELProf(event.currentTarget); // open profile popover if closed
    }
  };


  // get decision card from database
  const getDecisionCards = async () => {
    try {
      const response = await fetch(baseURL + '/api/decision/getDecisionCards', {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include"
      });
      const data = await response.json();
      if (response.ok) {
        // handle the data as needed
        // console.log("Decision card", data.data);
        dispatch(notification_success(data.data));
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      // console.error('Error:', error);
    }
  };


  useEffect(() => {
    if (profile_stat.profile_status.AcctType === "Client") {
      // console.log("Called decision card notification");
      getDecisionCards();
    }
  }, [])

  // const handleClose = (lg) => {
  //   handleLanguageChange(lg);
  //   dispatch(dispatchT_Language(lg));

    // console.log("language selected", lg);
  //   setTimeout(() => {
  //     console.log(language["Submit"]);
  //   }, 3000);

  //   setAnchorEL(null);
  // };

  const userPics = useSelector((prev) => prev.userInfo);
  const [picLink, setPicsLink] = useState("");
  const popupRef = useRef(null);
  const NotRef = useRef(null);

  useEffect(() => {
    // dispatch(LanguageTranslate_loading(true));
    if (profile_stat.profile_status?.AcctType === "Client") {
      if (employee !== null && employee?.photo !== undefined) {
        setPicsLink(employee?.photo);
      } else {
        if (userPics.user !== null) {
          setPicsLink(userPics.user?.profile_pics);
        }
      }
    }
  }, [profile_stat.profile_status.AcctType, userPics]);

  // This allow the user to click any part of their screen to close the mobile navigation
  useEffect(() => {
    // function that allow the user to close their mobile navigation
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleToggleMenu();
      }
    };

    const handleNotClickOutside = (event) => {
      if (NotRef.current && !NotRef.current.contains(event.target)) {
        setShowNot(!showNot);
      }
    };

    if (showNot) {
      document.addEventListener("mousedown", handleNotClickOutside);
    } else {
      document.removeEventListener("mousedown", handleNotClickOutside);
    }

    // monitor the user action on the navigation bar and close the bar
    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleNotClickOutside);

    };
  }, [showMenu, handleToggleMenu, showNot]);

  // Serves as a portal for our mobile navigation to get to the <div id="sidebarMobile"></div> in index.html 
  const sidebarModal = showMenu
    ? createPortal(
      <div
        className="absolute z-[11111] max-w-[280px] bg-white rounded-xl right-0 top-[45px] md:hidden"
        ref={popupRef}
      >
        <SideBar isForMenu={true} />
      </div>,
      document.getElementById("sidebarMobile")
    )
    : null;

  // console.log(showMenu);
  return (
    <header className="flex justify-between items-center px-8 py-3 border-b-[1.5px] border-sec-300 col-start-1 col-end-3 row-start-1 row-end-2 max-w-[100vw]">
      {profile_stat.profile_status?.AcctType === "Client" ? (
        <Link
          to={
            (profile_stat.profile_status?.profile_status === true || profile_stat.profile_status?.profile_status === "true") &&
              profile_stat.profile_status?.AcctType === "Client"
              ? "/user/dashboard"
              : "/user/welcome"
          }
        >
          <figure>
            <img
              src="https://res.cloudinary.com/drlcisipo/image/upload/v1705704261/Website%20images/logo_gox0fw.png"
              alt="Moil Logo"
              className={`w-[50px] ${sidebar ? 'cont:w-[100px]' : ''}`}
            />
            <figcaption className="sr-only">Moil Logo</figcaption>
          </figure>
        </Link>
      ) : (
        null
      )}

      {/* ipad:left-[90%] xtraxl:left-[94%] xxlarge:left-[95%] */}
      <div className="flex justify-between items-center gap-5 nav-right">
        <>
          {profile_stat.profile_status.AcctType === "Client" ?
            <>
              <button id="notification-bell" aria-describedby={id} className="px-2 py-2 ml-[20px] rounded-full bg-white bg-indigo-400 border relative border-indigo-400 border-opacity-50 border-4" onClick={handleClick}>
                {notification_list?.length > 0 ?
                  <>
                    <NotificationSvg />
                    <p className="absolute right-[-5px] top-[-5px] w-[24px] h-[24px] text-white bg-green-400 rounded-full flex items-center justify-center text-sm">{notification_list?.length}</p>
                  </>
                  : <NoNotificationSvg />}
              </button>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEL}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
              >
                <NotificationModal />
              </Popover></> :
            null
          }
        </>
        <div className="">
          <TranslateButton className='flex items-center' />
        </div>
        <figure aria-describedby={idProfile} className="xsm:mr-3 sm:mr-2 mr-0 cursor-pointer flex gap-x-1 items-center" onClick={handleClickProf}>
            <Avatar alt="Remy Sharp" src={picLink} />
            <ArrowDropDownIcon className={openProf && 'rotate-180'} />
          </figure>
        <Popover
            id={idProfile}
            open={openProf}
            anchorEl={anchorELProf}
            onClose={handleCloseProf}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <div className="p-4 flex hover:text-[#000000CC] justify-start min-w-[200px] md:min-w-[280px] flex-col gap-y-4 bg-white rounded-[4px] ">
              <NavLink className="flex gap-x-2 pb-4 border-b-[0.13px] border-black items-center"  to={`/user/profile/:${userPics?.user?.profile_id}`}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4C5 2.93913 5.42143 1.92172 6.17157 1.17157C6.92172 0.421427 7.93913 0 9 0C10.0609 0 11.0783 0.421427 11.8284 1.17157C12.5786 1.92172 13 2.93913 13 4C13 5.06087 12.5786 6.07828 11.8284 6.82843C11.0783 7.57857 10.0609 8 9 8C7.93913 8 6.92172 7.57857 6.17157 6.82843C5.42143 6.07828 5 5.06087 5 4ZM5 10C3.67392 10 2.40215 10.5268 1.46447 11.4645C0.526784 12.4021 0 13.6739 0 15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H15C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15C18 13.6739 17.4732 12.4021 16.5355 11.4645C15.5979 10.5268 14.3261 10 13 10H5Z" fill="#5843BD" />
                </svg>
                <p className="leading-normal text-[#000000CC]">View profile</p>
              </NavLink>

              {/* <NavLink className="flex  gap-x-2 pb-4 border-b-[0.13px] border-black items-center">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.208 2.83C12.6613 2.97 13.0947 3.15 13.508 3.37L15.341 2.27C15.5321 2.15536 15.7561 2.10786 15.9773 2.13504C16.1985 2.16221 16.4043 2.26251 16.562 2.42L17.58 3.438C17.7375 3.5957 17.8378 3.80149 17.865 4.02271C17.8921 4.24392 17.8446 4.46787 17.73 4.659L16.63 6.492C16.85 6.90533 17.03 7.33867 17.17 7.792L19.243 8.311C19.4592 8.36517 19.6512 8.49005 19.7883 8.66579C19.9255 8.84154 20 9.05807 20 9.281V10.719C20 10.9419 19.9255 11.1585 19.7883 11.3342C19.6512 11.51 19.4592 11.6348 19.243 11.689L17.17 12.208C17.03 12.6613 16.85 13.0947 16.63 13.508L17.73 15.341C17.8446 15.5321 17.8921 15.7561 17.865 15.9773C17.8378 16.1985 17.7375 16.4043 17.58 16.562L16.562 17.58C16.4043 17.7375 16.1985 17.8378 15.9773 17.865C15.7561 17.8921 15.5321 17.8446 15.341 17.73L13.508 16.63C13.0947 16.85 12.6613 17.03 12.208 17.17L11.689 19.243C11.6348 19.4592 11.51 19.6512 11.3342 19.7883C11.1585 19.9255 10.9419 20 10.719 20H9.281C9.05807 20 8.84154 19.9255 8.66579 19.7883C8.49005 19.6512 8.36517 19.4592 8.311 19.243L7.792 17.17C7.3427 17.0312 6.90744 16.8504 6.492 16.63L4.659 17.73C4.46787 17.8446 4.24392 17.8921 4.02271 17.865C3.80149 17.8378 3.5957 17.7375 3.438 17.58L2.42 16.562C2.26251 16.4043 2.16221 16.1985 2.13504 15.9773C2.10786 15.7561 2.15536 15.5321 2.27 15.341L3.37 13.508C3.14964 13.0926 2.96885 12.6573 2.83 12.208L0.757 11.689C0.540919 11.6349 0.349098 11.5101 0.211963 11.3346C0.074827 11.1591 0.000228643 10.9428 0 10.72V9.282C5.86043e-06 9.05907 0.0745022 8.84254 0.211655 8.66679C0.348809 8.49105 0.540753 8.36617 0.757 8.312L2.83 7.793C2.97 7.33967 3.15 6.90633 3.37 6.493L2.27 4.66C2.15536 4.46887 2.10786 4.24492 2.13504 4.02371C2.16221 3.80249 2.26251 3.5967 2.42 3.439L3.438 2.42C3.5957 2.26251 3.80149 2.16221 4.02271 2.13504C4.24392 2.10786 4.46787 2.15536 4.659 2.27L6.492 3.37C6.90533 3.15 7.33867 2.97 7.792 2.83L8.311 0.757C8.36513 0.540919 8.48986 0.349098 8.6654 0.211963C8.84094 0.074827 9.05724 0.000228643 9.28 0H10.718C10.9409 5.86043e-06 11.1575 0.0745022 11.3332 0.211655C11.509 0.348809 11.6338 0.540753 11.688 0.757L12.208 2.83ZM10 14C11.0609 14 12.0783 13.5786 12.8284 12.8284C13.5786 12.0783 14 11.0609 14 10C14 8.93913 13.5786 7.92172 12.8284 7.17157C12.0783 6.42143 11.0609 6 10 6C8.93913 6 7.92172 6.42143 7.17157 7.17157C6.42143 7.92172 6 8.93913 6 10C6 11.0609 6.42143 12.0783 7.17157 12.8284C7.92172 13.5786 8.93913 14 10 14Z" fill="#5843BD" />
                </svg>
                <p className="leading-normal text-[#000000CC]">Profile Settings</p>
              </NavLink> */}

              <NavLink className="flex gap-x-2 pb-4 hover:text-[#000000CC] items-center" to={"/logout"}>
                <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.375 6C0.375 6.702 0.375 7.053 0.544 7.306C0.616786 7.41478 0.71022 7.50821 0.819 7.581C1.072 7.75 1.423 7.75 2.125 7.75H6.375C6.97174 7.75 7.54403 7.98705 7.96599 8.40901C8.38795 8.83097 8.625 9.40326 8.625 10C8.625 10.5967 8.38795 11.169 7.96599 11.591C7.54403 12.0129 6.97174 12.25 6.375 12.25H2.125C1.423 12.25 1.072 12.25 0.819 12.418C0.710124 12.4911 0.616684 12.5849 0.544 12.694C0.375 12.947 0.375 13.298 0.375 14C0.375 16.828 0.375 18.243 1.254 19.121C2.132 20 3.546 20 6.374 20H7.374C10.204 20 11.617 20 12.496 19.121C13.375 18.243 13.375 16.828 13.375 14V6C13.375 3.172 13.375 1.757 12.496 0.879C11.617 0.000999928 10.203 0 7.375 0H6.375C3.546 0 2.132 -5.96046e-08 1.254 0.879C0.375 1.757 0.375 3.172 0.375 6Z" fill="#5843BD" />
                </svg>
                <p className="leading-normal text-[#000000CC]">Logout</p>
              </NavLink>


            </div>
          </Popover>
      </div>
    </header>
  );
};

export default TopBar;
